import * as React from 'react';
import type { SVGProps } from 'react';

const SvgLinkedinBlue = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={21} height={20} fill="none" {...props}>
    <path
      fill="#5B8ADA"
      d="M17.893 17.041h-3.112v-4.64c0-1.107-.02-2.532-1.618-2.532-1.62 0-1.868 1.206-1.868 2.45v4.722H8.183V7.497h2.987v1.305h.042c.299-.487.73-.888 1.25-1.159a3.407 3.407 0 0 1 1.697-.383c3.154 0 3.735 1.976 3.735 4.546l-.001 5.235ZM4.673 6.193c-.998 0-1.807-.77-1.807-1.72s.808-1.72 1.806-1.72c.997 0 1.805.77 1.806 1.72 0 .456-.19.893-.53 1.216a1.853 1.853 0 0 1-1.276.504Zm1.555 10.848H3.113V7.497h3.115v9.544ZM19.444.001H1.55C.704-.008.01.638 0 1.443v17.114c.01.806.704 1.451 1.55 1.443h17.894c.848.01 1.544-.636 1.556-1.443V1.442C20.988.635 20.292-.01 19.444 0"
    />
  </svg>
);
export default SvgLinkedinBlue;
